export const VIEW_GRAPH_PARAM = 'viewGraph';
export const VIEW_STATE_PARAM = 'vs';

export interface ViewerViewState {
  view?: { x: number; y: number; k: number };
  sel?: string;
  q?: string;
  palette?: string;
  clusters?: boolean;
  t?: number;
  focus?: string;
}

export const encodeViewState = (state: ViewerViewState): string =>
  btoa(encodeURIComponent(JSON.stringify(state)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');

export const decodeViewState = (raw: string | null): ViewerViewState | null => {
  if (!raw) return null;
  try {
    const base64 = raw.replace(/-/g, '+').replace(/_/g, '/');
    // Restore the '=' padding stripped by encodeViewState: spec-compliant
    // atob forgives its absence, but strict decoders in older WebViews may
    // not, and the payload travels in shared URLs across environments.
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
    return JSON.parse(decodeURIComponent(atob(padded))) as ViewerViewState;
  } catch {
    return null;
  }
};
